import * as Constants from "./constants";

export const required = (value: any) =>
  value && value.length > 0 ? undefined : Constants.requiredField;

export const validateEmail = (value: string) =>
  value && value.length > 0 && value.indexOf(".") > 0 && value.indexOf("@") > 0
    ? undefined
    : Constants.emailFormat;
